import { useAuth } from "features/auth";
import { useQuery } from "react-query";
import { api } from "utils/api";
import { voteKeys } from "./queryKeys";

const getUsersOpenCallVotes = () =>
  api.get<{ openCallIds: string[] }>("/open-call/vote/history");

/**
 * Get a user's vote history for all open calls
 *
 * NOTE: authenticated route, so user must be signed in
 */
const useUsersOpenCallVotes = () => {
  const { user } = useAuth();

  return useQuery(voteKeys.list(), getUsersOpenCallVotes, {
    enabled: !!user,
  });
};

export { useUsersOpenCallVotes };
